import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { createElementVNode as _createElementVNode, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, createBlock as _createBlock, withModifiers as _withModifiers, vShow as _vShow, normalizeStyle as _normalizeStyle, vModelRadio as _vModelRadio } from "vue";
const _hoisted_1 = {
  class: "flex gap-6 flex-1 min-h-0"
};
const _hoisted_2 = {
  class: "w-64 flex-shrink-0"
};
const _hoisted_3 = {
  class: "list-page-table-panel"
};
const _hoisted_4 = {
  class: "p-2 max-h-[600px] overflow-auto"
};
const _hoisted_5 = {
  class: "flex-1 min-w-0 flex flex-col"
};
const _hoisted_6 = {
  class: "list-page-table-panel list-page-table-panel--fill"
};
const _hoisted_7 = {
  class: "filter-bar-field is-wide relative"
};
const _hoisted_8 = {
  key: 0,
  class: "flex items-center gap-2"
};
const _hoisted_9 = {
  class: "px-2 py-1 bg-primary-100 text-primary-700 rounded text-sm"
};
const _hoisted_10 = {
  class: "data-table-shell"
};
const _hoisted_11 = {
  key: 0,
  class: "data-table-scroll data-table-scroll--fill p-4"
};
const _hoisted_12 = {
  class: "data-table min-w-[1280px]"
};
const _hoisted_13 = {
  class: "data-table-body data-table-skeleton"
};
const _hoisted_14 = {
  key: 1,
  class: "data-table-scroll data-table-scroll--fill"
};
const _hoisted_15 = {
  class: "data-table min-w-[1280px]"
};
const _hoisted_16 = {
  class: "data-table-head"
};
const _hoisted_17 = {
  class: "data-table-th text-left w-10"
};
const _hoisted_18 = {
  class: "data-table-body"
};
const _hoisted_19 = {
  class: "data-table-td"
};
const _hoisted_20 = ["onUpdate:modelValue"];
const _hoisted_21 = {
  class: "data-table-td"
};
const _hoisted_22 = ["src"];
const _hoisted_23 = {
  class: "data-table-td text-sm text-slate-900"
};
const _hoisted_24 = {
  class: "data-table-td text-sm text-slate-900"
};
const _hoisted_25 = {
  class: "data-table-td text-sm text-slate-900"
};
const _hoisted_26 = {
  class: "data-table-td text-sm text-slate-900"
};
const _hoisted_27 = {
  class: "data-table-td"
};
const _hoisted_28 = {
  class: "data-table-td text-sm text-slate-900"
};
const _hoisted_29 = {
  class: "data-table-td data-table-sticky-right data-table-sticky-action"
};
const _hoisted_30 = {
  class: "flex items-center gap-1"
};
const _hoisted_31 = ["onClick"];
const _hoisted_32 = ["onClick", "title", "aria-label"];
const _hoisted_33 = {
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_34 = {
  key: 0,
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
};
const _hoisted_35 = {
  key: 1,
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
};
const _hoisted_36 = ["onClick"];
const _hoisted_37 = ["onClick"];
const _hoisted_38 = ["onClick"];
const _hoisted_39 = ["onClick"];
const _hoisted_40 = {
  key: 0
};
const _hoisted_41 = {
  class: "px-6 py-4 border-b border-slate-200 flex items-center justify-between shrink-0"
};
const _hoisted_42 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_43 = {
  class: "flex-1 overflow-y-auto p-6"
};
const _hoisted_44 = {
  class: "grid grid-cols-2 gap-4"
};
const _hoisted_45 = {
  class: "col-span-2"
};
const _hoisted_46 = {
  class: "flex items-center gap-4"
};
const _hoisted_47 = {
  class: "relative"
};
const _hoisted_48 = {
  class: "w-20 h-20 rounded-full bg-slate-200 flex items-center justify-center overflow-hidden border-2 border-slate-300"
};
const _hoisted_49 = {
  key: 0,
  class: "text-2xl text-slate-400"
};
const _hoisted_50 = ["src"];
const _hoisted_51 = {
  class: "flex-1"
};
const _hoisted_52 = ["readonly"];
const _hoisted_53 = {
  key: 0
};
const _hoisted_54 = {
  class: "flex items-center gap-3"
};
const _hoisted_55 = {
  class: "form-switch"
};
const _hoisted_56 = {
  class: "text-sm text-slate-700"
};
const _hoisted_57 = {
  class: "relative"
};
const _hoisted_58 = {
  key: 0,
  class: "text-slate-400"
};
const _hoisted_59 = ["onClick"];
const _hoisted_60 = {
  class: "form-dropdown-panel absolute z-10 w-full"
};
const _hoisted_61 = ["value"];
const _hoisted_62 = {
  class: "text-sm"
};
const _hoisted_63 = {
  class: "relative"
};
const _hoisted_64 = {
  key: 0,
  class: "text-slate-400"
};
const _hoisted_65 = ["onClick"];
const _hoisted_66 = {
  class: "form-dropdown-panel absolute z-10 w-full"
};
const _hoisted_67 = ["value"];
const _hoisted_68 = {
  class: "text-sm"
};
const _hoisted_69 = {
  class: "col-span-2"
};
const _hoisted_70 = {
  key: 1,
  class: "col-span-2 border border-slate-200 rounded-lg p-4 bg-slate-50"
};
const _hoisted_71 = {
  class: "flex items-center justify-between mb-3"
};
const _hoisted_72 = {
  key: 0,
  class: "text-xs text-slate-400"
};
const _hoisted_73 = {
  class: "space-y-4"
};
const _hoisted_74 = {
  class: "block text-sm font-medium text-slate-700 mb-1"
};
const _hoisted_75 = {
  class: "flex items-center gap-4 mb-4"
};
const _hoisted_76 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_77 = {
  class: "text-sm text-slate-500"
};
const _hoisted_78 = {
  class: "flex items-center justify-end gap-3"
};
const _hoisted_79 = {
  class: "flex items-center gap-4 mb-5"
};
const _hoisted_80 = {
  class: "text-sm text-slate-500"
};
const _hoisted_81 = {
  class: "mb-5"
};
const _hoisted_82 = {
  class: "flex items-center justify-end gap-3"
};
const _hoisted_83 = ["disabled"];
const _hoisted_84 = {
  class: "px-6 py-4 border-b border-slate-200 flex items-center justify-between"
};
const _hoisted_85 = {
  class: "text-sm text-slate-500 mt-0.5"
};
const _hoisted_86 = {
  class: "px-6 border-b border-slate-200"
};
const _hoisted_87 = {
  class: "flex gap-6"
};
const _hoisted_88 = {
  class: "h-[calc(90vh-200px)] overflow-y-auto p-6"
};
const _hoisted_89 = {
  key: 0,
  class: "text-center text-sm text-slate-500 py-8"
};
const _hoisted_90 = {
  key: 1
};
const _hoisted_91 = {
  class: "border border-slate-300 rounded-lg p-4 bg-slate-50 max-h-80 overflow-y-auto"
};
const _hoisted_92 = {
  key: 0,
  class: "text-sm text-slate-500 text-center py-4"
};
const _hoisted_93 = ["onClick"];
const _hoisted_94 = {
  key: 1,
  class: "w-4 h-4"
};
const _hoisted_95 = {
  class: "flex items-center gap-2 cursor-pointer"
};
const _hoisted_96 = ["checked", "onChange"];
const _hoisted_97 = {
  class: "text-sm text-slate-700"
};
const _hoisted_98 = {
  key: 0,
  class: "text-center text-sm text-slate-500 py-8"
};
const _hoisted_99 = {
  key: 1,
  class: "text-center text-sm text-slate-500 py-8"
};
const _hoisted_100 = {
  key: 2,
  class: "border border-slate-300 rounded-lg overflow-hidden"
};
const _hoisted_101 = {
  class: "overflow-x-auto max-h-96 overflow-y-auto"
};
const _hoisted_102 = {
  class: "w-full"
};
const _hoisted_103 = {
  class: "bg-white divide-y divide-slate-200"
};
const _hoisted_104 = {
  class: "hover:bg-slate-50 transition-colors"
};
const _hoisted_105 = {
  class: "px-4 py-3"
};
const _hoisted_106 = {
  class: "flex flex-col"
};
const _hoisted_107 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_108 = {
  class: "text-xs text-slate-500 font-mono"
};
const _hoisted_109 = {
  class: "px-4 py-3 text-center"
};
const _hoisted_110 = {
  class: "inline-flex items-center justify-center cursor-pointer"
};
const _hoisted_111 = ["name", "onUpdate:modelValue", "onChange"];
const _hoisted_112 = {
  class: "px-4 py-3 text-center"
};
const _hoisted_113 = {
  class: "inline-flex items-center justify-center cursor-pointer"
};
const _hoisted_114 = ["name", "onUpdate:modelValue", "onChange"];
const _hoisted_115 = {
  class: "px-4 py-3 text-center"
};
const _hoisted_116 = {
  class: "inline-flex items-center justify-center cursor-pointer"
};
const _hoisted_117 = ["name", "onUpdate:modelValue", "onChange"];
const _hoisted_118 = {
  class: "px-4 py-3 text-center"
};
const _hoisted_119 = {
  class: "inline-flex items-center justify-center cursor-pointer"
};
const _hoisted_120 = ["name", "onUpdate:modelValue", "onChange"];
const _hoisted_121 = {
  class: "px-4 py-3 text-center"
};
const _hoisted_122 = {
  class: "inline-flex items-center justify-center cursor-pointer"
};
const _hoisted_123 = ["name", "onUpdate:modelValue", "onChange"];
const _hoisted_124 = {
  class: "px-4 py-3 text-center"
};
const _hoisted_125 = {
  class: "inline-flex items-center justify-center cursor-pointer"
};
const _hoisted_126 = ["name", "onUpdate:modelValue", "onChange"];
const _hoisted_127 = {
  key: 0,
  class: "bg-slate-50"
};
const _hoisted_128 = {
  colspan: "7",
  class: "px-4 py-3"
};
const _hoisted_129 = {
  class: "flex items-center gap-2"
};
const _hoisted_130 = {
  class: "px-6 py-4 border-t border-slate-200 flex items-center justify-end gap-3"
};
const _hoisted_131 = ["disabled"];
const _hoisted_132 = {
  class: "px-6 py-4 border-b border-slate-200 flex items-center justify-between"
};
const _hoisted_133 = {
  class: "text-sm text-slate-500 mt-0.5"
};
const _hoisted_134 = {
  class: "p-6 space-y-4"
};
const _hoisted_135 = {
  class: "relative"
};
const _hoisted_136 = {
  key: 0,
  class: "form-dropdown-panel absolute z-10 w-full"
};
const _hoisted_137 = ["onClick"];
const _hoisted_138 = {
  class: "font-medium"
};
const _hoisted_139 = {
  key: 0,
  class: "text-xs text-slate-400"
};
const _hoisted_140 = {
  key: 1,
  class: "absolute z-10 w-full mt-1 bg-white border border-slate-300 rounded-lg shadow-lg p-3 text-sm text-slate-500 text-center"
};
const _hoisted_141 = {
  key: 0,
  class: "mt-1.5 flex items-center gap-2"
};
const _hoisted_142 = {
  class: "px-2 py-0.5 bg-teal-100 text-teal-700 rounded text-xs"
};
const _hoisted_143 = {
  key: 0,
  class: "border border-slate-300 rounded-lg p-4 text-sm text-slate-400 text-center"
};
const _hoisted_144 = {
  key: 1,
  class: "border border-slate-300 rounded-lg p-4 text-sm text-slate-400 text-center"
};
const _hoisted_145 = {
  key: 2,
  class: "form-tree-panel max-h-48 overflow-auto"
};
const _hoisted_146 = {
  key: 3,
  class: "mt-1 text-xs text-slate-500"
};
const _hoisted_147 = {
  class: "relative"
};
const _hoisted_148 = {
  key: 0,
  class: "text-slate-400"
};
const _hoisted_149 = ["onClick"];
const _hoisted_150 = {
  class: "form-dropdown-panel absolute z-10 w-full"
};
const _hoisted_151 = ["value"];
const _hoisted_152 = {
  class: "text-sm"
};
const _hoisted_153 = {
  class: "relative"
};
const _hoisted_154 = {
  key: 0,
  class: "text-slate-400"
};
const _hoisted_155 = ["onClick"];
const _hoisted_156 = {
  class: "form-dropdown-panel absolute z-10 w-full"
};
const _hoisted_157 = ["value"];
const _hoisted_158 = {
  class: "text-sm"
};
const _hoisted_159 = {
  class: "px-6 py-4 border-t border-slate-200 flex items-center justify-end gap-3"
};
const _hoisted_160 = ["disabled"];
const _hoisted_161 = {
  class: "px-6 py-4 border-b border-slate-200 flex items-center justify-between"
};
const _hoisted_162 = {
  class: "text-sm text-slate-500 mt-0.5"
};
const _hoisted_163 = {
  class: "p-6"
};
const _hoisted_164 = {
  key: 0,
  class: "flex items-center justify-center py-8"
};
const _hoisted_165 = {
  key: 1,
  class: "space-y-4"
};
const _hoisted_166 = {
  class: "bg-indigo-50 border border-indigo-200 rounded-lg p-4"
};
const _hoisted_167 = {
  class: "space-y-2 text-sm"
};
const _hoisted_168 = {
  class: "flex items-center justify-between"
};
const _hoisted_169 = {
  class: "text-slate-900 font-mono"
};
const _hoisted_170 = {
  key: 0,
  class: "flex items-center justify-between"
};
const _hoisted_171 = {
  class: "text-slate-900 font-mono"
};
const _hoisted_172 = {
  class: "flex items-center justify-between"
};
const _hoisted_173 = {
  key: 1,
  class: "flex items-center justify-between"
};
const _hoisted_174 = {
  class: "text-slate-900"
};
const _hoisted_175 = {
  class: "flex items-center justify-end"
};
const _hoisted_176 = ["disabled"];
const _hoisted_177 = {
  key: 2,
  class: "space-y-4"
};
const _hoisted_178 = {
  class: "flex items-center justify-end gap-3"
};
const _hoisted_179 = ["disabled"];
import { ref, reactive, computed, onMounted, watch } from 'vue';
import { ElMessage } from 'element-plus';
import DeptTree from './components/DeptTree.vue';
import DeptSelector from '@/components/DeptSelector/index.vue';
import AppPagination from '@/components/AppPagination.vue';
import ListPageShell from '@/components/ListPageShell.vue';
import PageFilterBar from '@/components/PageFilterBar.vue';
import { getUserList, createUser, updateUser, disableUser, getUserDataScope, saveUserDataScope, deleteUserDataScope, getUserDirectMenuIds, grantUserDirectMenus, resetPassword, bindTenant, getAssistantRelations, saveAssistantRelation, disableAssistantRelation } from '@/api';
import { getAllDataScopeResources } from '@/api/role';
import { getDeptTree } from '@/api/dept';
import { getRoles } from '@/api/role';
import { getMenuTree } from '@/api/menu';
import { getPosts } from '@/api/post';
import { uploadFile } from '@/api/file';
import { compressImage } from '@/utils/imageCompress';
import { getFranchiseePage } from '@/api/franchisee';
import { getWeWorkBinding, bindWeWork, unbindWeWork } from '@/api/weworkKf';
import AppModal from '@/components/AppModal.vue';
export default {
  __name: 'UserManagement',
  setup(__props) {
    const searchForm = reactive({
      username: '',
      phone: '',
      status: ''
    });
    const loading = ref(false);
    const showUserModal = ref(false);
    const showDisableModal = ref(false);
    const isEdit = ref(false);
    const selectedDeptId = ref(null);
    const toggleStatusUser = ref(null);
    const selectAll = ref(false);
    const currentPage = ref(1);
    const pageSize = ref(10);
    const total = ref(50);
    const totalPages = computed(() => Math.ceil(total.value / pageSize.value) || 1);
    const avatarInput = ref(null);
    const showRoleDropdown = ref(false);
    const showPositionDropdown = ref(false);

    // 展开状态对象 (使用普通对象，Vue 响应式追踪更可靠)
    const expandedIds = reactive({});
    const modalExpandedIds = reactive({});
    const deptTree = ref([]);
    const findDeptById = (id, list = deptTree.value) => {
      if (!id) return null;
      for (const item of list) {
        if (item.id === id) return item;
        if (item.children?.length) {
          const found = findDeptById(id, item.children);
          if (found) return found;
        }
      }
      return null;
    };
    const findDeptIdByName = (name, list = deptTree.value) => {
      if (!name) return null;
      for (const item of list) {
        if (item.name === name) return item.id;
        if (item.children?.length) {
          const found = findDeptIdByName(name, item.children);
          if (found) return found;
        }
      }
      return null;
    };
    const roleOptions = ref([]);
    const positionOptions = ref([]);
    const userList = ref([]);
    const assistantPrincipalOptions = ref([]);
    const assistantRelationLoading = ref(false);
    const ASSISTANT_RELATION_CONFIGS = [{
      assistantRoleKey: 'FA-ASSIST',
      principalRoleKeys: ['FA'],
      relationType: 'PLANNER_ASSISTANT',
      label: '关联规划师',
      placeholder: '请选择可查看数据的规划师'
    }, {
      assistantRoleKey: 'FINANCE-ASSIST',
      principalRoleKeys: ['FINANCE-MANAGER', 'FINANCE-MAIN'],
      relationType: 'FINANCE_ASSISTANT',
      label: '关联主管会计',
      placeholder: '请选择可查看数据的主管会计'
    }];
    const assistantRelationForm = reactive({
      PLANNER_ASSISTANT: [],
      FINANCE_ASSISTANT: []
    });
    const originalAssistantRelationForm = reactive({
      PLANNER_ASSISTANT: [],
      FINANCE_ASSISTANT: []
    });
    const userForm = reactive({
      id: null,
      nickname: '',
      username: '',
      deptId: '',
      phone: '',
      email: '',
      password: '',
      gender: '0',
      status: 0,
      statusSwitch: false,
      roles: [],
      positions: [],
      remark: '',
      avatar: '',
      avatarKey: '',
      avatarFile: null
    });
    const filteredUserList = computed(() => {
      return userList.value;
    });
    const selectedRoles = computed(() => {
      const normalizedRoleIds = userForm.roles.map(id => String(id));
      return roleOptions.value.filter(r => normalizedRoleIds.includes(String(r.value)));
    });
    const selectedRoleKeys = computed(() => {
      return selectedRoles.value.map(role => role.roleKey).filter(Boolean);
    });
    const activeAssistantRelationConfigs = computed(() => {
      return ASSISTANT_RELATION_CONFIGS.filter(config => selectedRoleKeys.value.includes(config.assistantRoleKey));
    });
    const showAssistantRelationPanel = computed(() => {
      return isEdit.value && activeAssistantRelationConfigs.value.length > 0;
    });
    const selectedPositions = computed(() => {
      return positionOptions.value.filter(p => userForm.positions.includes(p.value));
    });
    const selectedDeptName = computed(() => {
      return findDeptById(selectedDeptId.value)?.name || '';
    });
    const getUserRoleIds = user => {
      return user.roleIds || user.roles || [];
    };
    const getRoleKeysByIds = (roleIds = []) => {
      const normalizedRoleIds = roleIds.map(id => String(id));
      return roleOptions.value.filter(role => normalizedRoleIds.includes(String(role.value))).map(role => role.roleKey).filter(Boolean);
    };
    const formatUserOptionLabel = user => {
      const name = user.displayName || user.nickname || user.username || `用户${user.id}`;
      const phone = user.phone ? `（${user.phone}）` : '';
      return `${name}${phone}`;
    };
    const resetAssistantRelationForm = () => {
      Object.keys(assistantRelationForm).forEach(key => {
        assistantRelationForm[key] = [];
        originalAssistantRelationForm[key] = [];
      });
    };
    const getPrincipalOptions = config => {
      const availableUsers = assistantPrincipalOptions.value.filter(user => user.id !== userForm.id);
      const matchedUsers = availableUsers.filter(user => {
        const roleKeys = getRoleKeysByIds(getUserRoleIds(user));
        return roleKeys.some(roleKey => {
          if (config.relationType === 'PLANNER_ASSISTANT') {
            return roleKey !== 'FA-ASSIST' && roleKey.startsWith('FA');
          }
          return config.principalRoleKeys.includes(roleKey);
        });
      });
      const filtered = matchedUsers.length > 0 ? matchedUsers : availableUsers;
      return filtered.map(user => ({
        value: user.id,
        label: formatUserOptionLabel(user)
      }));
    };
    const loadAssistantPrincipalOptions = async () => {
      try {
        const res = await getUserList({
          page: 1,
          size: 500
        });
        const records = Array.isArray(res?.records) ? res.records : [];
        assistantPrincipalOptions.value = records.map(u => ({
          ...u,
          nickname: u.displayName || u.nickname,
          roleIds: u.roleIds || u.roles || [],
          postIds: u.postIds || u.positions || []
        }));
      } catch (error) {
        console.error('加载助理绑定候选用户失败:', error);
        assistantPrincipalOptions.value = [];
      }
    };
    const loadAssistantRelations = async assistantUserId => {
      resetAssistantRelationForm();
      if (!assistantUserId) return;
      assistantRelationLoading.value = true;
      try {
        const [relations] = await Promise.all([getAssistantRelations(assistantUserId), assistantPrincipalOptions.value.length > 0 ? Promise.resolve() : loadAssistantPrincipalOptions()]);
        const list = Array.isArray(relations) ? relations : [];
        const optionIds = new Set(assistantPrincipalOptions.value.map(user => user.id));
        ASSISTANT_RELATION_CONFIGS.forEach(config => {
          const ids = list.filter(item => item.relationType === config.relationType).map(item => item.principalUserId).filter(Boolean);
          ids.forEach(id => {
            if (!optionIds.has(id)) {
              assistantPrincipalOptions.value.push({
                id,
                nickname: `用户${id}`,
                username: `用户${id}`,
                roleIds: [],
                postIds: []
              });
              optionIds.add(id);
            }
          });
          assistantRelationForm[config.relationType] = [...ids];
          originalAssistantRelationForm[config.relationType] = [...ids];
        });
      } catch (error) {
        console.error('加载助理绑定关系失败:', error);
        ElMessage.error(error.message || '加载助理绑定关系失败');
      } finally {
        assistantRelationLoading.value = false;
      }
    };
    const syncAssistantRelations = async () => {
      if (!isEdit.value || !userForm.id) return;
      const activeRelationTypes = activeAssistantRelationConfigs.value.map(config => config.relationType);
      const tasks = [];
      ASSISTANT_RELATION_CONFIGS.forEach(config => {
        const relationType = config.relationType;
        const currentIds = activeRelationTypes.includes(relationType) ? assistantRelationForm[relationType] : [];
        const originalIds = originalAssistantRelationForm[relationType];
        const addedIds = currentIds.filter(id => !originalIds.includes(id));
        const removedIds = originalIds.filter(id => !currentIds.includes(id));
        addedIds.forEach(principalUserId => {
          tasks.push(saveAssistantRelation({
            assistantUserId: userForm.id,
            principalUserId,
            relationType
          }));
        });
        removedIds.forEach(principalUserId => {
          tasks.push(disableAssistantRelation({
            assistantUserId: userForm.id,
            principalUserId,
            relationType
          }));
        });
      });
      if (tasks.length > 0) {
        await Promise.all(tasks);
      }
    };
    const selectDept = dept => {
      selectedDeptId.value = dept.id;
      currentPage.value = 1;
      loadUserList();
    };
    const clearDeptFilter = () => {
      selectedDeptId.value = null;
      currentPage.value = 1;
      loadUserList();
    };
    const handlePageChange = page => {
      currentPage.value = page;
      loadUserList();
    };
    const handlePageSizeChange = size => {
      pageSize.value = size;
      currentPage.value = 1;
      loadUserList();
    };
    const toggleDept = deptId => {
      expandedIds[deptId] = !expandedIds[deptId];
    };

    // 用户表单部门选择（DeptSelector 单选为 {id,name} 对象，同步纯 id 到 userForm）
    const userDeptSelection = ref(null);
    watch(userDeptSelection, val => {
      userForm.deptId = val ? typeof val === 'object' ? val.id : val : '';
    });
    const toggleModalDept = deptId => {
      modalExpandedIds[deptId] = !modalExpandedIds[deptId];
    };
    const handleSearch = async () => {
      currentPage.value = 1;
      await loadUserList();
    };
    const resetSearch = () => {
      searchForm.username = '';
      searchForm.phone = '';
      searchForm.status = '';
      loadUserList();
    };
    const handleSelectAll = () => {
      userList.value.forEach(u => u.selected = selectAll.value);
    };
    const isUserDisabled = computed(() => toggleStatusUser.value?.status === 1);
    const handleDisable = user => {
      toggleStatusUser.value = user;
      showDisableModal.value = true;
    };
    const confirmDisable = async () => {
      try {
        loading.value = true;
        await disableUser(toggleStatusUser.value.id);
        ElMessage.success(isUserDisabled.value ? '启用成功' : '禁用成功');
        showDisableModal.value = false;
        loadUserList();
      } catch (error) {
        console.error(isUserDisabled.value ? '启用失败:' : '禁用失败:', error);
        ElMessage.error(error.message || (isUserDisabled.value ? '启用失败' : '禁用失败'));
      } finally {
        loading.value = false;
      }
    };
    const showResetPwdModal = ref(false);
    const resetPwdUser = ref(null);
    const resetPwdLoading = ref(false);
    const resetPwdForm = reactive({
      newPassword: ''
    });
    const resetUserPassword = user => {
      resetPwdUser.value = user;
      resetPwdForm.newPassword = '';
      showResetPwdModal.value = true;
    };
    const confirmResetPassword = async () => {
      if (!resetPwdForm.newPassword.trim()) {
        ElMessage.warning('请输入新密码');
        return;
      }
      resetPwdLoading.value = true;
      try {
        await resetPassword({
          userId: resetPwdUser.value.id,
          newPassword: resetPwdForm.newPassword
        });
        ElMessage.success('密码重置成功');
        showResetPwdModal.value = false;
      } catch (error) {
        console.error('重置密码失败:', error);
        ElMessage.error(error.message || '重置密码失败');
      } finally {
        resetPwdLoading.value = false;
      }
    };
    const openAddModal = () => {
      isEdit.value = false;
      resetAssistantRelationForm();
      Object.assign(userForm, {
        id: null,
        nickname: '',
        username: '',
        deptId: '',
        phone: '',
        email: '',
        password: '',
        gender: '0',
        status: 0,
        statusSwitch: false,
        roles: [],
        positions: [],
        remark: '',
        avatar: '',
        avatarKey: '',
        avatarFile: null
      });
      userDeptSelection.value = null;
      showUserModal.value = true;
    };
    const openEditModal = async user => {
      isEdit.value = true;
      const resolvedDeptId = user.deptId || findDeptIdByName(user.dept) || '';
      Object.assign(userForm, {
        id: user.id,
        nickname: user.nickname || user.username,
        username: user.nickname || user.username,
        deptId: resolvedDeptId,
        phone: user.phone,
        email: user.email || '',
        password: '',
        gender: String(user.gender || '0'),
        status: user.status,
        statusSwitch: user.status === 1,
        roles: user.roleIds || user.roles || [],
        positions: user.postIds || user.positions || [],
        remark: user.remark || '',
        avatar: user.avatar || '',
        avatarKey: '',
        avatarFile: null
      });
      userDeptSelection.value = resolvedDeptId ? {
        id: resolvedDeptId,
        name: findDeptById(resolvedDeptId)?.name || user.deptName || user.dept || ''
      } : null;
      showUserModal.value = true;
      await loadAssistantRelations(user.id);
    };
    const closeUserModal = () => {
      showUserModal.value = false;
    };
    const saveUser = async () => {
      // 表单验证
      if (!userForm.nickname.trim()) {
        ElMessage.warning('请输入姓名');
        return;
      }
      if (!userForm.deptId) {
        ElMessage.warning('请选择部门');
        return;
      }
      if (!userForm.phone.trim()) {
        ElMessage.warning('请输入手机号码');
        return;
      }
      if (!isEdit.value && !userForm.password) {
        ElMessage.warning('请输入密码');
        return;
      }
      try {
        loading.value = true;

        // 如果选择了头像，先压缩再上传
        if (userForm.avatarFile) {
          const compressed = await compressImage(userForm.avatarFile, {
            maxWidth: 400,
            maxHeight: 400,
            quality: 0.8
          });
          const res = await uploadFile(compressed, 'avatar', 'public');
          userForm.avatarKey = res.fileName || res.data?.fileName;
        }
        const data = {
          username: userForm.nickname,
          displayName: userForm.nickname,
          phone: userForm.phone,
          email: userForm.email || undefined,
          gender: parseInt(userForm.gender),
          status: userForm.status,
          deptId: userForm.deptId || undefined,
          roleIds: userForm.roles,
          postIds: userForm.positions,
          avatar: userForm.avatarKey || undefined
        };
        if (!isEdit.value) {
          data.password = userForm.password;
          await createUser(data);
          ElMessage.success('添加成功');
        } else {
          await updateUser(userForm.id, data);
          await syncAssistantRelations();
          ElMessage.success('更新成功');
        }
        closeUserModal();
        loadUserList();
      } catch (error) {
        console.error('保存失败:', error);
        ElMessage.error(error.message || '保存失败');
      } finally {
        loading.value = false;
      }
    };
    const triggerAvatarUpload = () => {
      avatarInput.value?.click();
    };
    const handleAvatarChange = event => {
      const file = event.target.files[0];
      if (file) {
        if (file.size > 2 * 1024 * 1024) {
          ElMessage.warning('图片大小不能超过 2MB');
          return;
        }
        // 显示本地预览
        const reader = new FileReader();
        reader.onload = e => {
          userForm.avatar = e.target.result;
        };
        reader.readAsDataURL(file);
        // 保存原始文件，用于后续上传
        userForm.avatarFile = file;
      }
    };
    const updateStatusFromSwitch = () => {
      userForm.status = userForm.statusSwitch ? 1 : 0;
    };
    const toggleRoleDropdown = () => {
      showRoleDropdown.value = !showRoleDropdown.value;
      showPositionDropdown.value = false;
    };
    const togglePositionDropdown = () => {
      showPositionDropdown.value = !showPositionDropdown.value;
      showRoleDropdown.value = false;
    };
    const removeRole = value => {
      const index = userForm.roles.indexOf(value);
      if (index > -1) userForm.roles.splice(index, 1);
      if (showAssistantRelationPanel.value) {
        loadAssistantPrincipalOptions();
      }
    };
    const removePosition = value => {
      const index = userForm.positions.indexOf(value);
      if (index > -1) userForm.positions.splice(index, 1);
    };
    const getAvatarBg = user => {
      const colors = ['bg-primary-100', 'bg-green-100', 'bg-red-100', 'bg-orange-100', 'bg-purple-100'];
      const index = user.id % colors.length;
      return colors[index];
    };
    const getAvatarTextColor = user => {
      const colors = ['text-primary-700', 'text-green-700', 'text-red-700', 'text-orange-700', 'text-purple-700'];
      const index = user.id % colors.length;
      return colors[index];
    };

    // 加载用户列表
    const loadUserList = async () => {
      try {
        loading.value = true;
        const params = {
          page: currentPage.value,
          size: pageSize.value
        };
        if (searchForm.username) params.username = searchForm.username;
        if (searchForm.phone) params.phone = searchForm.phone;
        if (searchForm.status) params.status = parseInt(searchForm.status);
        if (selectedDeptId.value) params.deptId = selectedDeptId.value;
        const res = await getUserList(params);
        userList.value = res.records.map(u => ({
          ...u,
          selected: false,
          nickname: u.displayName || u.nickname,
          roleIds: u.roleIds || [],
          postIds: u.postIds || []
        }));
        total.value = res.total;
      } catch (error) {
        console.error('加载用户列表失败:', error);
        ElMessage.error('加载用户列表失败');
      } finally {
        loading.value = false;
      }
    };

    // 加载部门树
    const loadDeptTree = async () => {
      try {
        const res = await getDeptTree();
        deptTree.value = res;
        // 默认展开所有节点
        const expandAll = list => {
          list.forEach(item => {
            expandedIds[item.id] = true;
            modalExpandedIds[item.id] = true;
            if (item.children?.length) {
              expandAll(item.children);
            }
          });
        };
        if (res.length > 0) {
          expandAll(res);
        }
      } catch (error) {
        console.error('加载部门树失败:', error);
        ElMessage.error('加载部门树失败');
      }
    };

    // 加载角色列表
    const loadRoles = async () => {
      try {
        const res = await getRoles();
        roleOptions.value = res.map(r => ({
          value: r.id,
          label: r.name,
          roleKey: r.roleKey || r.role_key
        }));
      } catch (error) {
        console.error('加载角色列表失败:', error);
      }
    };

    // 加载岗位列表
    const loadPosts = async () => {
      try {
        const res = await getPosts();
        // 兼容分页数据和非分页数据，兼容不同字段名
        const list = Array.isArray(res) ? res : res.records || [];
        positionOptions.value = list.map(p => ({
          value: p.id || p.postId,
          label: p.name || p.postName || p.code
        }));
      } catch (error) {
        console.error('加载岗位列表失败:', error);
      }
    };

    // 初始化
    onMounted(async () => {
      await loadDeptTree();
      await loadUserList();
      await loadRoles();
      await loadPosts();
    });

    // 点击外部关闭下拉框
    document.addEventListener('click', e => {
      if (!e.target.closest('.relative')) {
        showRoleDropdown.value = false;
        showPositionDropdown.value = false;
      }
    });

    // ========== 用户权限配置（菜单权限 + 数据权限） ==========
    const showDataScopeModal = ref(false);
    const dataScopeUser = ref(null);
    const dataScopeLoading = ref(false);
    const dataScopeSaving = ref(false);
    const userResourceScopes = ref([]);
    const permissionTab = ref('menu');

    // ---- 菜单权限 ----
    const userMenuTree = ref([]);
    const userMenuExpandedIds = ref([]);
    const userMenuSelectedIds = ref([]);
    const userMenuLoading = ref(false);

    // 扁平化菜单树
    const flattenedUserMenuTree = computed(() => {
      const result = [];
      const traverse = (nodes, level) => {
        if (!Array.isArray(nodes)) return;
        nodes.forEach(node => {
          result.push({
            node,
            level
          });
          if (node.children && Array.isArray(node.children) && userMenuExpandedIds.value.includes(node.id)) {
            traverse(node.children, level + 1);
          }
        });
      };
      traverse(userMenuTree.value, 0);
      return result;
    });
    const toggleUserMenuExpand = menuId => {
      if (userMenuExpandedIds.value.includes(menuId)) {
        userMenuExpandedIds.value = userMenuExpandedIds.value.filter(id => id !== menuId);
      } else {
        userMenuExpandedIds.value = [...userMenuExpandedIds.value, menuId];
      }
    };
    const isUserMenuChecked = node => {
      return userMenuSelectedIds.value.includes(node.id);
    };

    // 收集所有有子节点的节点ID（用于默认展开）
    const collectMenuExpandIds = nodes => {
      const ids = [];
      if (!Array.isArray(nodes)) return ids;
      nodes.forEach(node => {
        if (node.children && Array.isArray(node.children) && node.children.length > 0 && Number.isFinite(node.id)) {
          ids.push(node.id);
          ids.push(...collectMenuExpandIds(node.children));
        }
      });
      return ids;
    };
    const onUserMenuCheck = (node, event) => {
      const checked = event.target.checked;
      if (checked) {
        if (!userMenuSelectedIds.value.includes(node.id)) userMenuSelectedIds.value.push(node.id);
      } else {
        userMenuSelectedIds.value = userMenuSelectedIds.value.filter(id => id !== node.id);
      }
    };

    // 从接口返回的 menuIds 应用选中状态
    const applyUserMenuSelection = (menuIds = []) => {
      const menuIdSet = new Set(menuIds);
      userMenuSelectedIds.value = [];
      const traverse = item => {
        if (menuIdSet.has(item.id) && Number.isFinite(item.id)) {
          userMenuSelectedIds.value.push(item.id);
        }
        if (item.children && Array.isArray(item.children)) {
          item.children.forEach(traverse);
        }
      };
      userMenuTree.value.forEach(traverse);
    };

    // 收集所有选中的菜单ID
    const collectUserMenuIds = () => {
      return [...userMenuSelectedIds.value];
    };

    // ---- 数据权限部门名称回填 ----
    // 构建部门 id → name 映射（DeptSelector 的 v-model 需要 {id,name} 对象显示名称）
    const buildDeptNameMap = () => {
      const map = {};
      const traverse = nodes => {
        if (!Array.isArray(nodes)) return;
        nodes.forEach(node => {
          map[node.id] = node.name;
          if (node.children?.length) traverse(node.children);
        });
      };
      traverse(deptTree.value);
      return map;
    };

    // 打开权限配置弹窗
    const openDataScopeModal = async user => {
      dataScopeUser.value = user;
      showDataScopeModal.value = true;
      permissionTab.value = 'menu';
      dataScopeLoading.value = true;
      userMenuLoading.value = true;
      try {
        // 并行加载菜单树、用户菜单权限、资源列表、用户数据权限
        const [menuTreeData, userMenuIds, allResources, userScopes] = await Promise.all([getMenuTree(), getUserDirectMenuIds(user.id), getAllDataScopeResources(), getUserDataScope(user.id)]);

        // 菜单树
        userMenuTree.value = Array.isArray(menuTreeData) ? menuTreeData : [];
        userMenuExpandedIds.value = collectMenuExpandIds(userMenuTree.value);
        const menuIds = Array.isArray(userMenuIds) ? userMenuIds : [];
        applyUserMenuSelection(menuIds);
        userMenuLoading.value = false;

        // 数据权限
        const enabledResources = Array.isArray(allResources) ? allResources.filter(r => r.status === 0) : [];
        const existingScopes = Array.isArray(userScopes) ? userScopes : [];
        userResourceScopes.value = enabledResources.map(resource => {
          const existing = existingScopes.find(s => s.resourceCode === resource.resourceCode);
          return {
            resourceCode: resource.resourceCode,
            resourceName: resource.resourceName,
            dataScope: existing?.dataScope || 0,
            deptSelection: (existing?.deptIds || []).map(id => ({
              id,
              name: ''
            })),
            remark: existing?.remark || ''
          };
        });
        if (userResourceScopes.value.some(r => r.deptSelection.length > 0)) {
          if (deptTree.value.length === 0) {
            await loadDeptTree();
          }
          const nameMap = buildDeptNameMap();
          userResourceScopes.value.forEach(resource => {
            resource.deptSelection = resource.deptSelection.map(d => ({
              id: d.id,
              name: nameMap[d.id] || ''
            }));
          });
        }
      } catch (error) {
        console.error('加载权限配置失败:', error);
        ElMessage.error('加载权限配置失败');
      } finally {
        dataScopeLoading.value = false;
        userMenuLoading.value = false;
      }
    };

    // 关闭权限配置弹窗
    const closeDataScopeModal = () => {
      showDataScopeModal.value = false;
      dataScopeUser.value = null;
      userResourceScopes.value = [];
      userMenuTree.value = [];
      userMenuSelectedIds.value = [];
      userMenuExpandedIds.value = [];
    };

    // 资源数据范围变化
    const onUserResourceDataScopeChange = index => {
      const resource = userResourceScopes.value[index];
      if (resource.dataScope !== 5) {
        resource.deptSelection = [];
      }
    };

    // 统一保存：菜单权限 + 数据权限
    const saveUserPermissions = async () => {
      const userId = dataScopeUser.value?.id;
      if (!userId) return;

      // 校验自定义范围是否选了部门
      for (const resource of userResourceScopes.value) {
        if (resource.dataScope === 5 && resource.deptSelection.length === 0) {
          ElMessage.warning(`资源「${resource.resourceName}」选择了自定义范围，请选择部门`);
          permissionTab.value = 'data';
          return;
        }
      }
      dataScopeSaving.value = true;
      try {
        const promises = [];

        // 1. 保存菜单权限
        promises.push(grantUserDirectMenus(userId, {
          userId,
          menuIds: collectUserMenuIds()
        }));

        // 2. 保存数据权限
        const toSave = userResourceScopes.value.filter(r => r.dataScope > 0);
        const toDelete = userResourceScopes.value.filter(r => r.dataScope === 0);
        for (const resource of toSave) {
          promises.push(saveUserDataScope({
            userId,
            resourceCode: resource.resourceCode,
            dataScope: resource.dataScope,
            deptIds: resource.dataScope === 5 ? resource.deptSelection.map(d => typeof d === 'object' ? d.id : d) : [],
            remark: resource.remark || ''
          }));
        }
        for (const resource of toDelete) {
          promises.push(deleteUserDataScope(userId, resource.resourceCode).catch(() => {}));
        }
        await Promise.all(promises);
        ElMessage.success('权限保存成功');
        closeDataScopeModal();
      } catch (error) {
        console.error('保存权限失败:', error);
        ElMessage.error(error.message || '保存权限失败');
      } finally {
        dataScopeSaving.value = false;
      }
    };

    // ========== 分配加盟商（租户） ==========
    const showBindTenantModal = ref(false);
    const bindTenantUser = ref(null);
    const bindTenantLoading = ref(false);
    const tenantListLoading = ref(false);
    const tenantList = ref([]);
    const tenantSearchKeyword = ref('');
    const showTenantDropdown = ref(false);
    const showBindTenantRoleDropdown = ref(false);
    const showBindTenantPostDropdown = ref(false);
    const bindTenantForm = reactive({
      tenantId: null,
      tenantName: '',
      deptId: null,
      roleIds: [],
      postIds: [],
      nickname: ''
    });
    const filteredTenantList = computed(() => {
      if (!tenantSearchKeyword.value) return tenantList.value;
      const keyword = tenantSearchKeyword.value.toLowerCase();
      return tenantList.value.filter(t => t.name?.toLowerCase().includes(keyword));
    });

    // 根据选中的加盟商tenantId过滤部门树
    const bindTenantDeptTree = computed(() => {
      const tid = bindTenantForm.tenantId;
      if (!tid) return [];
      const filterTree = nodes => {
        if (!Array.isArray(nodes)) return [];
        const result = [];
        for (const node of nodes) {
          if (node.tenantId === tid) {
            result.push({
              ...node,
              children: filterTree(node.children)
            });
          } else if (node.children?.length) {
            const filtered = filterTree(node.children);
            if (filtered.length > 0) {
              result.push({
                ...node,
                children: filtered
              });
            }
          }
        }
        return result;
      };
      return filterTree(deptTree.value);
    });
    const loadTenantList = async () => {
      tenantListLoading.value = true;
      try {
        const res = await getFranchiseePage({
          current: 1,
          size: 200,
          statuses: [3]
        });
        tenantList.value = res.records || [];
      } catch (error) {
        console.error('加载加盟商列表失败:', error);
        ElMessage.error('加载加盟商列表失败');
      } finally {
        tenantListLoading.value = false;
      }
    };
    const openBindTenantModal = user => {
      bindTenantUser.value = user;
      Object.assign(bindTenantForm, {
        tenantId: null,
        tenantName: '',
        deptId: null,
        roleIds: [],
        postIds: [],
        nickname: ''
      });
      tenantSearchKeyword.value = '';
      showTenantDropdown.value = false;
      showBindTenantRoleDropdown.value = false;
      showBindTenantPostDropdown.value = false;
      showBindTenantModal.value = true;
      loadTenantList();
    };
    const closeBindTenantModal = () => {
      showBindTenantModal.value = false;
      bindTenantUser.value = null;
    };
    const selectTenantOption = tenant => {
      bindTenantForm.tenantId = tenant.id;
      bindTenantForm.tenantName = tenant.name;
      bindTenantForm.deptId = null;
      tenantSearchKeyword.value = tenant.name;
      showTenantDropdown.value = false;
    };
    const clearTenantSelection = () => {
      bindTenantForm.tenantId = null;
      bindTenantForm.tenantName = '';
      bindTenantForm.deptId = null;
      tenantSearchKeyword.value = '';
    };
    const searchTenants = () => {
      showTenantDropdown.value = true;
    };
    const confirmBindTenant = async () => {
      if (!bindTenantForm.tenantId) {
        ElMessage.warning('请选择加盟商');
        return;
      }
      if (!bindTenantForm.deptId) {
        ElMessage.warning('请选择部门');
        return;
      }
      bindTenantLoading.value = true;
      try {
        await bindTenant({
          tenantId: bindTenantForm.tenantId,
          phone: bindTenantUser.value.phone,
          deptId: bindTenantForm.deptId,
          roleIds: bindTenantForm.roleIds.length > 0 ? bindTenantForm.roleIds : undefined,
          postIds: bindTenantForm.postIds.length > 0 ? bindTenantForm.postIds : undefined,
          nickname: bindTenantForm.nickname || undefined
        });
        ElMessage.success('分配加盟商成功');
        closeBindTenantModal();
      } catch (error) {
        console.error('分配加盟商失败:', error);
        ElMessage.error(error.message || '分配加盟商失败');
      } finally {
        bindTenantLoading.value = false;
      }
    };

    // ========== 绑定企业微信 ==========
    const showWeWorkBindModal = ref(false);
    const weWorkBindUser = ref(null);
    const weWorkBindInfo = ref(null);
    const weWorkBindLoading = ref(false);
    const weWorkSubmitLoading = ref(false);
    const weWorkUnbindLoading = ref(false);
    const weWorkBindForm = reactive({
      weworkUserId: ''
    });
    const openWeWorkBindModal = async user => {
      weWorkBindUser.value = user;
      weWorkBindInfo.value = null;
      weWorkBindForm.weworkUserId = '';
      showWeWorkBindModal.value = true;
      weWorkBindLoading.value = true;
      try {
        const res = await getWeWorkBinding(user.id);
        if (res && res.weworkUserId) {
          weWorkBindInfo.value = res;
        }
      } catch {
        // 未绑定时接口可能返回错误，忽略
      } finally {
        weWorkBindLoading.value = false;
      }
    };
    const closeWeWorkBindModal = () => {
      showWeWorkBindModal.value = false;
      weWorkBindUser.value = null;
      weWorkBindInfo.value = null;
    };
    const confirmBindWeWork = async () => {
      if (!weWorkBindForm.weworkUserId.trim()) {
        ElMessage.warning('请输入企业微信成员UserID');
        return;
      }
      weWorkSubmitLoading.value = true;
      try {
        await bindWeWork({
          userId: weWorkBindUser.value.id,
          weworkUserId: weWorkBindForm.weworkUserId.trim()
        });
        ElMessage.success('绑定成功');
        // 刷新绑定信息
        const res = await getWeWorkBinding(weWorkBindUser.value.id);
        if (res && res.weworkUserId) {
          weWorkBindInfo.value = res;
        }
      } catch (error) {
        console.error('绑定企微失败:', error);
        ElMessage.error(error.message || '绑定失败');
      } finally {
        weWorkSubmitLoading.value = false;
      }
    };
    const handleUnbindWeWork = async () => {
      weWorkUnbindLoading.value = true;
      try {
        await unbindWeWork(weWorkBindUser.value.id);
        ElMessage.success('解绑成功');
        weWorkBindInfo.value = null;
      } catch (error) {
        console.error('解绑企微失败:', error);
        ElMessage.error(error.message || '解绑失败');
      } finally {
        weWorkUnbindLoading.value = false;
      }
    };
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createBlock(ListPageShell, {
        fill: ""
      }, {
        header: _withCtx(() => [...(_cache[30] || (_cache[30] = [_createElementVNode("div", {
          class: "list-page-panel is-header-minimal"
        }, [_createElementVNode("div", {
          class: "list-page-heading"
        }, [_createElementVNode("div", {
          class: "list-page-heading-main"
        }, [_createElementVNode("h1", {
          class: "list-page-title"
        }, "用户管理"), _createElementVNode("p", {
          class: "list-page-description"
        }, "按部门查看用户信息，统一处理账号与权限配置")])])], -1)]))]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[31] || (_cache[31] = _createElementVNode("div", {
          class: "px-4 py-3 border-b border-slate-200 bg-slate-50"
        }, [_createElementVNode("h3", {
          class: "text-sm font-medium text-slate-700"
        }, "部门列表")], -1)), _createElementVNode("div", _hoisted_4, [_createVNode(DeptTree, {
          "tree-data": deptTree.value,
          "selected-dept-id": selectedDeptId.value,
          "expanded-ids": expandedIds,
          onSelect: selectDept,
          onToggle: toggleDept
        }, null, 8, ["tree-data", "selected-dept-id", "expanded-ids"])])])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(PageFilterBar, {
          "shell-class": "filter-bar-shell is-embedded",
          "body-class": "filter-bar-body is-panel",
          "show-refresh": "",
          "refresh-loading": loading.value,
          onRefresh: loadUserList
        }, {
          searchActionsLeading: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: openAddModal,
            class: "btn-primary"
          }, [...(_cache[33] || (_cache[33] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 4v16m8-8H4"
          })], -1), _createTextVNode(" 新增 ", -1)]))])), [[_directive_permission, 'system:user:add']])]),
          searchActions: _withCtx(() => [_createElementVNode("button", {
            type: "button",
            onClick: handleSearch,
            class: "btn-primary"
          }, "搜索"), _createElementVNode("button", {
            type: "button",
            onClick: resetSearch,
            class: "btn-secondary"
          }, "重置")]),
          extra: _withCtx(() => [selectedDeptId.value ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_cache[34] || (_cache[34] = _createElementVNode("span", {
            class: "text-sm text-slate-500"
          }, "当前部门：", -1)), _createElementVNode("span", _hoisted_9, _toDisplayString(selectedDeptName.value), 1), _createElementVNode("button", {
            type: "button",
            onClick: clearDeptFilter,
            class: "text-sm text-primary-600 hover:text-primary-800"
          }, "清除")])) : _createCommentVNode("", true)]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => searchForm.username = $event),
            type: "text",
            placeholder: "请输入姓名",
            class: "form-search-input form-control-sm w-full",
            onKeyup: _withKeys(handleSearch, ["enter"])
          }, null, 544), [[_vModelText, searchForm.username]]), _cache[32] || (_cache[32] = _createElementVNode("svg", {
            class: "absolute left-3 top-2.5 h-4 w-4 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          })], -1))]), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => searchForm.phone = $event),
            type: "text",
            placeholder: "请输入手机号码",
            class: "form-input form-control-sm filter-bar-field"
          }, null, 512), [[_vModelText, searchForm.phone]]), _createVNode(_component_el_select, {
            modelValue: searchForm.status,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => searchForm.status = $event),
            placeholder: "请选择状态",
            class: "form-select form-control-sm filter-bar-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部状态",
              value: ""
            }), _createVNode(_component_el_option, {
              label: "正常",
              value: "0"
            }), _createVNode(_component_el_option, {
              label: "停用",
              value: "1"
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }, 8, ["refresh-loading"]), _createElementVNode("div", _hoisted_10, [loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("table", _hoisted_12, [_cache[36] || (_cache[36] = _createElementVNode("thead", {
          class: "data-table-head"
        }, [_createElementVNode("tr", null, [_createElementVNode("th", {
          class: "data-table-th text-left w-10"
        }, [_createElementVNode("div", {
          class: "h-4 w-4 bg-slate-200 rounded"
        })]), _createElementVNode("th", {
          class: "data-table-th text-left w-16"
        }, [_createElementVNode("div", {
          class: "h-4 w-4 bg-slate-200 rounded"
        })]), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, [_createElementVNode("div", {
          class: "h-4 w-20 bg-slate-200 rounded"
        })]), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, [_createElementVNode("div", {
          class: "h-4 w-20 bg-slate-200 rounded"
        })]), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, [_createElementVNode("div", {
          class: "h-4 w-20 bg-slate-200 rounded"
        })]), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, [_createElementVNode("div", {
          class: "h-4 w-16 bg-slate-200 rounded"
        })]), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, [_createElementVNode("div", {
          class: "h-4 w-20 bg-slate-200 rounded"
        })]), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, [_createElementVNode("div", {
          class: "h-4 w-12 bg-slate-200 rounded"
        })]), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, [_createElementVNode("div", {
          class: "h-4 w-24 bg-slate-200 rounded"
        })]), _createElementVNode("th", {
          class: "data-table-th text-left w-32"
        }, [_createElementVNode("div", {
          class: "h-4 w-16 bg-slate-200 rounded"
        })])])], -1)), _createElementVNode("tbody", _hoisted_13, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, n => {
          return _createElementVNode("tr", {
            key: n,
            class: "animate-pulse"
          }, [...(_cache[35] || (_cache[35] = [_createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "h-4 w-4 bg-slate-200 rounded"
          })], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "w-8 h-8 rounded-full bg-slate-200"
          })], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "h-4 w-16 bg-slate-200 rounded"
          })], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "h-4 w-20 bg-slate-200 rounded"
          })], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "h-4 w-20 bg-slate-200 rounded"
          })], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "h-4 w-16 bg-slate-200 rounded"
          })], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "h-4 w-24 bg-slate-200 rounded"
          })], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "h-6 w-14 bg-slate-200 rounded-full"
          })], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "h-4 w-24 bg-slate-200 rounded"
          })], -1), _createElementVNode("td", {
            class: "data-table-td data-table-sticky-right data-table-sticky-action"
          }, [_createElementVNode("div", {
            class: "flex items-center gap-1"
          }, [_createElementVNode("div", {
            class: "h-8 w-8 bg-slate-200 rounded"
          }), _createElementVNode("div", {
            class: "h-8 w-8 bg-slate-200 rounded"
          }), _createElementVNode("div", {
            class: "h-8 w-8 bg-slate-200 rounded"
          })])], -1)]))]);
        }), 64))])])])) : (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("table", _hoisted_15, [_createElementVNode("thead", _hoisted_16, [_createElementVNode("tr", null, [_createElementVNode("th", _hoisted_17, [_withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => selectAll.value = $event),
          onChange: handleSelectAll,
          class: "form-check"
        }, null, 544), [[_vModelCheckbox, selectAll.value]])]), _cache[37] || (_cache[37] = _createElementVNode("th", {
          class: "data-table-th text-left w-16"
        }, "头像", -1)), _cache[38] || (_cache[38] = _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "用户编号", -1)), _cache[39] || (_cache[39] = _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "姓名", -1)), _cache[40] || (_cache[40] = _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "部门", -1)), _cache[41] || (_cache[41] = _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "手机号码", -1)), _cache[42] || (_cache[42] = _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "状态", -1)), _cache[43] || (_cache[43] = _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "创建时间", -1)), _cache[44] || (_cache[44] = _createElementVNode("th", {
          class: "data-table-th text-left data-table-sticky-right data-table-sticky-head data-table-sticky-action"
        }, "操作", -1))])]), _createElementVNode("tbody", _hoisted_18, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredUserList.value, user => {
          return _openBlock(), _createElementBlock("tr", {
            key: user.id,
            class: "data-table-row"
          }, [_createElementVNode("td", _hoisted_19, [_withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": $event => user.selected = $event,
            class: "form-check"
          }, null, 8, _hoisted_20), [[_vModelCheckbox, user.selected]])]), _createElementVNode("td", _hoisted_21, [_createElementVNode("div", {
            class: _normalizeClass(["w-8 h-8 rounded-full flex items-center justify-center overflow-hidden", getAvatarBg(user)])
          }, [user.avatarUrl ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: user.avatarUrl,
            class: "w-full h-full object-cover"
          }, null, 8, _hoisted_22)) : (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: _normalizeClass(["text-sm font-medium", getAvatarTextColor(user)])
          }, _toDisplayString(user.nickname?.charAt(0)), 3))], 2)]), _createElementVNode("td", _hoisted_23, _toDisplayString(user.id), 1), _createElementVNode("td", _hoisted_24, _toDisplayString(user.displayName || user.nickname || user.username), 1), _createElementVNode("td", _hoisted_25, _toDisplayString(user.deptName || user.dept), 1), _createElementVNode("td", _hoisted_26, _toDisplayString(user.phone), 1), _createElementVNode("td", _hoisted_27, [_createElementVNode("span", {
            class: _normalizeClass(["status-badge", user.status === 0 ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'])
          }, [_createElementVNode("span", {
            class: _normalizeClass(["w-1.5 h-1.5 rounded-full mr-1", user.status === 0 ? 'bg-green-500' : 'bg-red-500'])
          }, null, 2), _createTextVNode(" " + _toDisplayString(user.status === 0 ? '正常' : '停用'), 1)], 2)]), _createElementVNode("td", _hoisted_28, _toDisplayString(_ctx.$formatDateTime(user.createTime)), 1), _createElementVNode("td", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: $event => openEditModal(user),
            class: "table-action-button is-primary",
            title: "修改",
            "aria-label": "修改"
          }, [...(_cache[45] || (_cache[45] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
          })], -1)]))], 8, _hoisted_31)), [[_directive_permission, 'system:user:edit']]), _withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: $event => handleDisable(user),
            class: _normalizeClass(["table-action-button", user.status === 1 ? 'is-success' : 'is-neutral']),
            title: user.status === 1 ? '启用' : '禁用',
            "aria-label": user.status === 1 ? '启用' : '禁用'
          }, [(_openBlock(), _createElementBlock("svg", _hoisted_33, [user.status === 1 ? (_openBlock(), _createElementBlock("path", _hoisted_34)) : (_openBlock(), _createElementBlock("path", _hoisted_35))]))], 10, _hoisted_32)), [[_directive_permission, 'system:user:edit']]), _withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: $event => resetUserPassword(user),
            class: "table-action-button is-neutral",
            title: "重置密码",
            "aria-label": "重置密码"
          }, [...(_cache[46] || (_cache[46] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
          })], -1)]))], 8, _hoisted_36)), [[_directive_permission, 'system:user:resetPwd']]), _createElementVNode("button", {
            onClick: $event => openDataScopeModal(user),
            class: "table-action-button is-purple",
            title: "数据权限",
            "aria-label": "数据权限"
          }, [...(_cache[47] || (_cache[47] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
          })], -1)]))], 8, _hoisted_37), _createElementVNode("button", {
            onClick: $event => openBindTenantModal(user),
            class: "table-action-button is-teal",
            title: "分配加盟商",
            "aria-label": "分配加盟商"
          }, [...(_cache[48] || (_cache[48] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
          })], -1)]))], 8, _hoisted_38), _createElementVNode("button", {
            onClick: $event => openWeWorkBindModal(user),
            class: "table-action-button is-indigo",
            title: "绑定企微",
            "aria-label": "绑定企微"
          }, [...(_cache[49] || (_cache[49] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
          })], -1)]))], 8, _hoisted_39)])])]);
        }), 128)), filteredUserList.value.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_40, [...(_cache[50] || (_cache[50] = [_createElementVNode("td", {
          colspan: "10",
          class: "data-table-empty text-slate-500"
        }, "暂无数据", -1)]))])) : _createCommentVNode("", true)])])]))]), total.value > 0 ? (_openBlock(), _createBlock(AppPagination, {
          key: 0,
          class: "pagination-bridge",
          current: currentPage.value,
          size: pageSize.value,
          total: total.value,
          pages: totalPages.value,
          "page-sizes": [10, 20, 50],
          onPageChange: handlePageChange,
          onSizeChange: handlePageSizeChange
        }, null, 8, ["current", "size", "total", "pages"])) : _createCommentVNode("", true)])])]), _createVNode(AppModal, {
          visible: showUserModal.value,
          size: "4xl",
          onClose: closeUserModal
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_41, [_createElementVNode("h3", _hoisted_42, _toDisplayString(isEdit.value ? '编辑用户' : '新增用户'), 1), _createElementVNode("button", {
            onClick: closeUserModal,
            class: "p-2 text-slate-400 hover:text-slate-600 rounded-lg hover:bg-slate-100 transition-colors"
          }, [...(_cache[51] || (_cache[51] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_43, [_createElementVNode("form", _hoisted_44, [_createElementVNode("div", _hoisted_45, [_cache[54] || (_cache[54] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, "头像", -1)), _createElementVNode("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, [_createElementVNode("div", _hoisted_48, [!userForm.avatar ? (_openBlock(), _createElementBlock("span", _hoisted_49, _toDisplayString(userForm.nickname?.charAt(0) || '用'), 1)) : (_openBlock(), _createElementBlock("img", {
            key: 1,
            src: userForm.avatar,
            class: "w-full h-full object-cover"
          }, null, 8, _hoisted_50))]), _createElementVNode("button", {
            type: "button",
            onClick: triggerAvatarUpload,
            class: "absolute -bottom-1 -right-1 w-8 h-8 bg-primary-700 text-white rounded-full flex items-center justify-center hover:bg-primary-800 transition-colors shadow-lg"
          }, [...(_cache[52] || (_cache[52] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 4v16m8-8H4"
          })], -1)]))])]), _createElementVNode("div", _hoisted_51, [_createElementVNode("input", {
            type: "file",
            ref_key: "avatarInput",
            ref: avatarInput,
            accept: "image/*",
            onChange: handleAvatarChange,
            class: "hidden"
          }, null, 544), _createElementVNode("button", {
            type: "button",
            onClick: triggerAvatarUpload,
            class: "btn-secondary"
          }, "选择图片"), _cache[53] || (_cache[53] = _createElementVNode("p", {
            class: "text-xs text-slate-500 mt-1"
          }, "支持 jpg、png 格式，大小不超过 2MB", -1))])])]), _createElementVNode("div", null, [_cache[55] || (_cache[55] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, [_createTextVNode("姓名 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => userForm.nickname = $event),
            type: "text",
            required: "",
            placeholder: "请输入姓名",
            class: "form-input w-full"
          }, null, 512), [[_vModelText, userForm.nickname]])]), _createElementVNode("div", null, [_cache[56] || (_cache[56] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, [_createTextVNode("部门 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _createVNode(DeptSelector, {
            modelValue: userDeptSelection.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => userDeptSelection.value = $event),
            multiple: false,
            placeholder: "请选择部门"
          }, null, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[57] || (_cache[57] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, [_createTextVNode("手机号码 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => userForm.phone = $event),
            type: "text",
            required: "",
            placeholder: "请输入手机号码",
            readonly: isEdit.value,
            class: _normalizeClass(isEdit.value ? 'form-readonly w-full' : 'form-input w-full')
          }, null, 10, _hoisted_52), [[_vModelText, userForm.phone]])]), _createElementVNode("div", null, [_cache[58] || (_cache[58] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "邮箱", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => userForm.email = $event),
            type: "email",
            placeholder: "请输入邮箱",
            class: "form-input w-full"
          }, null, 512), [[_vModelText, userForm.email]])]), !isEdit.value ? (_openBlock(), _createElementBlock("div", _hoisted_53, [_cache[59] || (_cache[59] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, [_createTextVNode("密码 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => userForm.password = $event),
            type: "password",
            required: "",
            placeholder: "请输入密码",
            class: "form-input w-full"
          }, null, 512), [[_vModelText, userForm.password]])])) : _createCommentVNode("", true), _createElementVNode("div", null, [_cache[60] || (_cache[60] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "性别", -1)), _createVNode(_component_el_select, {
            modelValue: userForm.gender,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => userForm.gender = $event),
            class: "form-select w-full"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "男",
              value: "0"
            }), _createVNode(_component_el_option, {
              label: "女",
              value: "1"
            }), _createVNode(_component_el_option, {
              label: "未知",
              value: "2"
            })]),
            _: 1
          }, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[62] || (_cache[62] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "状态", -1)), _createElementVNode("div", _hoisted_54, [_createElementVNode("label", _hoisted_55, [_withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => userForm.statusSwitch = $event),
            class: "form-switch-input",
            onChange: updateStatusFromSwitch
          }, null, 544), [[_vModelCheckbox, userForm.statusSwitch]]), _cache[61] || (_cache[61] = _createElementVNode("span", {
            class: "form-switch-track"
          }, null, -1))]), _createElementVNode("span", _hoisted_56, _toDisplayString(userForm.status === 0 ? '正常' : '停用'), 1)])]), _createElementVNode("div", null, [_cache[64] || (_cache[64] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "角色", -1)), _createElementVNode("div", _hoisted_57, [_createElementVNode("div", {
            onClick: toggleRoleDropdown,
            class: _normalizeClass(['form-selector-trigger w-full', {
              'is-active': showRoleDropdown.value
            }])
          }, [selectedRoles.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_58, "请选择角色")) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedRoles.value, role => {
            return _openBlock(), _createElementBlock("span", {
              key: role.value,
              class: "inline-flex items-center gap-1 px-2 py-0.5 bg-primary-100 text-primary-700 rounded text-xs"
            }, [_createTextVNode(_toDisplayString(role.label) + " ", 1), _createElementVNode("button", {
              type: "button",
              onClick: _withModifiers($event => removeRole(role.value), ["stop"]),
              class: "hover:text-primary-900"
            }, [...(_cache[63] || (_cache[63] = [_createElementVNode("svg", {
              class: "w-3.5 h-3.5",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M6 18L18 6M6 6l12 12"
            })], -1)]))], 8, _hoisted_59)]);
          }), 128))], 2), _withDirectives(_createElementVNode("div", _hoisted_60, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roleOptions.value, role => {
            return _openBlock(), _createElementBlock("label", {
              key: role.value,
              class: "flex items-center gap-2 px-3 py-2 hover:bg-slate-50 cursor-pointer"
            }, [_withDirectives(_createElementVNode("input", {
              type: "checkbox",
              value: role.value,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => userForm.roles = $event),
              class: "role-checkbox form-check"
            }, null, 8, _hoisted_61), [[_vModelCheckbox, userForm.roles]]), _createElementVNode("span", _hoisted_62, _toDisplayString(role.label), 1)]);
          }), 128))], 512), [[_vShow, showRoleDropdown.value]])])]), _createElementVNode("div", null, [_cache[66] || (_cache[66] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "岗位", -1)), _createElementVNode("div", _hoisted_63, [_createElementVNode("div", {
            onClick: togglePositionDropdown,
            class: _normalizeClass(['form-selector-trigger w-full', {
              'is-active': showPositionDropdown.value
            }])
          }, [selectedPositions.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_64, "请选择岗位")) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedPositions.value, pos => {
            return _openBlock(), _createElementBlock("span", {
              key: pos.value,
              class: "inline-flex items-center gap-1 px-2 py-0.5 bg-green-100 text-green-700 rounded text-xs"
            }, [_createTextVNode(_toDisplayString(pos.label) + " ", 1), _createElementVNode("button", {
              type: "button",
              onClick: _withModifiers($event => removePosition(pos.value), ["stop"]),
              class: "hover:text-green-900"
            }, [...(_cache[65] || (_cache[65] = [_createElementVNode("svg", {
              class: "w-3.5 h-3.5",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M6 18L18 6M6 6l12 12"
            })], -1)]))], 8, _hoisted_65)]);
          }), 128))], 2), _withDirectives(_createElementVNode("div", _hoisted_66, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(positionOptions.value, pos => {
            return _openBlock(), _createElementBlock("label", {
              key: pos.value,
              class: "flex items-center gap-2 px-3 py-2 hover:bg-slate-50 cursor-pointer"
            }, [_withDirectives(_createElementVNode("input", {
              type: "checkbox",
              value: pos.value,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => userForm.positions = $event),
              class: "position-checkbox form-check"
            }, null, 8, _hoisted_67), [[_vModelCheckbox, userForm.positions]]), _createElementVNode("span", _hoisted_68, _toDisplayString(pos.label), 1)]);
          }), 128))], 512), [[_vShow, showPositionDropdown.value]])])]), _createElementVNode("div", _hoisted_69, [_cache[67] || (_cache[67] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "备注", -1)), _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => userForm.remark = $event),
            rows: "3",
            placeholder: "请输入备注信息",
            class: "form-textarea"
          }, null, 512), [[_vModelText, userForm.remark]])]), showAssistantRelationPanel.value ? (_openBlock(), _createElementBlock("div", _hoisted_70, [_createElementVNode("div", _hoisted_71, [_cache[68] || (_cache[68] = _createElementVNode("div", null, [_createElementVNode("div", {
            class: "text-sm font-medium text-slate-800"
          }, "助理关系绑定"), _createElementVNode("p", {
            class: "text-xs text-slate-500 mt-0.5"
          }, "绑定后，助理可查看所关联主用户的数据。")], -1)), assistantRelationLoading.value ? (_openBlock(), _createElementBlock("span", _hoisted_72, "加载中...")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_73, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeAssistantRelationConfigs.value, config => {
            return _openBlock(), _createElementBlock("div", {
              key: config.relationType
            }, [_createElementVNode("label", _hoisted_74, _toDisplayString(config.label), 1), _createVNode(_component_el_select, {
              modelValue: assistantRelationForm[config.relationType],
              "onUpdate:modelValue": $event => assistantRelationForm[config.relationType] = $event,
              multiple: "",
              filterable: "",
              clearable: "",
              "collapse-tags": "",
              "collapse-tags-tooltip": "",
              placeholder: config.placeholder,
              class: "w-full"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getPrincipalOptions(config), option => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: `${config.relationType}-${option.value}`,
                  label: option.label,
                  value: option.value,
                  disabled: option.value === userForm.id
                }, null, 8, ["label", "value", "disabled"]);
              }), 128))]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder"])]);
          }), 128))])])) : _createCommentVNode("", true)])]), _createElementVNode("div", {
            class: "px-6 py-4 border-t border-slate-200 flex items-center justify-end gap-3 shrink-0"
          }, [_createElementVNode("button", {
            onClick: closeUserModal,
            class: "btn-secondary"
          }, "取消"), _createElementVNode("button", {
            onClick: saveUser,
            class: "btn-primary"
          }, "确定")])]),
          _: 1
        }, 8, ["visible"]), _createVNode(AppModal, {
          visible: showDisableModal.value,
          size: "sm",
          "panel-class": "p-6 mx-4",
          onClose: _cache[15] || (_cache[15] = $event => showDisableModal.value = false)
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_75, [_createElementVNode("div", {
            class: _normalizeClass(["w-12 h-12 rounded-full flex items-center justify-center", isUserDisabled.value ? 'bg-green-100' : 'bg-orange-100'])
          }, [(_openBlock(), _createElementBlock("svg", {
            class: _normalizeClass(["w-6 h-6", isUserDisabled.value ? 'text-green-600' : 'text-orange-600']),
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [...(_cache[69] || (_cache[69] = [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
          }, null, -1)]))], 2))], 2), _createElementVNode("div", null, [_createElementVNode("h3", _hoisted_76, _toDisplayString(isUserDisabled.value ? '确认启用' : '确认禁用'), 1), _createElementVNode("p", _hoisted_77, _toDisplayString(isUserDisabled.value ? '确定要启用该用户吗？启用后用户可正常登录系统。' : '确定要禁用该用户吗？禁用后用户将无法登录系统。'), 1)])]), _createElementVNode("div", _hoisted_78, [_createElementVNode("button", {
            onClick: _cache[14] || (_cache[14] = $event => showDisableModal.value = false),
            class: "btn-secondary"
          }, "取消"), _createElementVNode("button", {
            onClick: confirmDisable,
            class: _normalizeClass(["px-4 py-2 text-white rounded-lg text-sm transition-colors", isUserDisabled.value ? 'bg-green-600 hover:bg-green-700' : 'bg-orange-600 hover:bg-orange-700'])
          }, _toDisplayString(isUserDisabled.value ? '启用' : '禁用'), 3)])]),
          _: 1
        }, 8, ["visible"]), _createVNode(AppModal, {
          visible: showResetPwdModal.value,
          size: "sm",
          "panel-class": "p-6 mx-4",
          onClose: _cache[18] || (_cache[18] = $event => showResetPwdModal.value = false)
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_79, [_cache[71] || (_cache[71] = _createElementVNode("div", {
            class: "w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0"
          }, [_createElementVNode("svg", {
            class: "w-6 h-6 text-amber-600",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"
          })])], -1)), _createElementVNode("div", null, [_cache[70] || (_cache[70] = _createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "重置密码", -1)), _createElementVNode("p", _hoisted_80, "用户：" + _toDisplayString(resetPwdUser.value?.nickname || resetPwdUser.value?.username), 1)])]), _createElementVNode("div", _hoisted_81, [_cache[72] || (_cache[72] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, [_createTextVNode("新密码 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => resetPwdForm.newPassword = $event),
            type: "password",
            placeholder: "请输入新密码",
            class: "form-input w-full"
          }, null, 512), [[_vModelText, resetPwdForm.newPassword]]), _cache[73] || (_cache[73] = _createElementVNode("p", {
            class: "text-xs text-slate-400 mt-1.5"
          }, "重置后用户需重新登录并修改默认密码", -1))]), _createElementVNode("div", _hoisted_82, [_createElementVNode("button", {
            onClick: _cache[17] || (_cache[17] = $event => showResetPwdModal.value = false),
            class: "btn-secondary"
          }, "取消"), _createElementVNode("button", {
            onClick: confirmResetPassword,
            disabled: resetPwdLoading.value,
            class: "btn-primary"
          }, _toDisplayString(resetPwdLoading.value ? '重置中...' : '确认重置'), 9, _hoisted_83)])]),
          _: 1
        }, 8, ["visible"]), _createVNode(AppModal, {
          visible: showDataScopeModal.value,
          size: "3xl",
          scrollable: false,
          onClose: closeDataScopeModal
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_84, [_createElementVNode("div", null, [_cache[74] || (_cache[74] = _createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "权限配置", -1)), _createElementVNode("p", _hoisted_85, "用户：" + _toDisplayString(dataScopeUser.value?.nickname || dataScopeUser.value?.username) + "（优先级高于角色配置）", 1)]), _createElementVNode("button", {
            onClick: closeDataScopeModal,
            class: "p-2 text-slate-400 hover:text-slate-600 rounded-lg hover:bg-slate-100 transition-colors"
          }, [...(_cache[75] || (_cache[75] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_86, [_createElementVNode("div", _hoisted_87, [_createElementVNode("button", {
            onClick: _cache[19] || (_cache[19] = $event => permissionTab.value = 'menu'),
            class: _normalizeClass(["py-3 text-sm font-medium border-b-2 transition-colors", permissionTab.value === 'menu' ? 'border-primary-600 text-primary-600' : 'border-transparent text-slate-500 hover:text-slate-700'])
          }, "菜单权限", 2), _createElementVNode("button", {
            onClick: _cache[20] || (_cache[20] = $event => permissionTab.value = 'data'),
            class: _normalizeClass(["py-3 text-sm font-medium border-b-2 transition-colors", permissionTab.value === 'data' ? 'border-primary-600 text-primary-600' : 'border-transparent text-slate-500 hover:text-slate-700'])
          }, "数据权限", 2)])]), _createElementVNode("div", _hoisted_88, [_withDirectives(_createElementVNode("div", null, [userMenuLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_89, [...(_cache[76] || (_cache[76] = [_createElementVNode("div", {
            class: "flex items-center justify-center gap-2"
          }, [_createElementVNode("svg", {
            class: "w-5 h-5 animate-spin text-primary-600",
            fill: "none",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("circle", {
            class: "opacity-25",
            cx: "12",
            cy: "12",
            r: "10",
            stroke: "currentColor",
            "stroke-width": "4"
          }), _createElementVNode("path", {
            class: "opacity-75",
            fill: "currentColor",
            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          })]), _createTextVNode(" 加载菜单树... ")], -1)]))])) : (_openBlock(), _createElementBlock("div", _hoisted_90, [_createElementVNode("div", _hoisted_91, [flattenedUserMenuTree.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_92, "暂无菜单数据")) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(flattenedUserMenuTree.value, item => {
            return _openBlock(), _createElementBlock("div", {
              key: item.node.id,
              class: "flex items-center gap-2 py-1",
              style: _normalizeStyle({
                paddingLeft: `${item.level * 16}px`
              })
            }, [item.node.children && item.node.children.length > 0 ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "expand-btn p-0.5 hover:bg-slate-200 rounded transition-colors",
              onClick: $event => toggleUserMenuExpand(item.node.id)
            }, [(_openBlock(), _createElementBlock("svg", {
              class: "w-4 h-4 text-slate-500 transition-transform",
              style: _normalizeStyle({
                transform: userMenuExpandedIds.value.includes(item.node.id) ? 'rotate(90deg)' : 'rotate(0deg)'
              }),
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [...(_cache[77] || (_cache[77] = [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M9 5l7 7-7 7"
            }, null, -1)]))], 4))], 8, _hoisted_93)) : (_openBlock(), _createElementBlock("span", _hoisted_94)), _createElementVNode("label", _hoisted_95, [_createElementVNode("input", {
              type: "checkbox",
              class: "form-check",
              checked: isUserMenuChecked(item.node),
              onChange: $event => onUserMenuCheck(item.node, $event)
            }, null, 40, _hoisted_96), _createElementVNode("span", _hoisted_97, _toDisplayString(item.node.name), 1)])], 4);
          }), 128))])]))], 512), [[_vShow, permissionTab.value === 'menu']]), _withDirectives(_createElementVNode("div", null, [dataScopeLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_98, [...(_cache[78] || (_cache[78] = [_createElementVNode("div", {
            class: "flex items-center justify-center gap-2"
          }, [_createElementVNode("svg", {
            class: "w-5 h-5 animate-spin text-primary-600",
            fill: "none",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("circle", {
            class: "opacity-25",
            cx: "12",
            cy: "12",
            r: "10",
            stroke: "currentColor",
            "stroke-width": "4"
          }), _createElementVNode("path", {
            class: "opacity-75",
            fill: "currentColor",
            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          })]), _createTextVNode(" 加载资源列表... ")], -1)]))])) : userResourceScopes.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_99, " 暂无可配置的资源 ")) : (_openBlock(), _createElementBlock("div", _hoisted_100, [_createElementVNode("div", _hoisted_101, [_createElementVNode("table", _hoisted_102, [_cache[80] || (_cache[80] = _createElementVNode("thead", {
            class: "bg-slate-50 sticky top-0 z-10"
          }, [_createElementVNode("tr", {
            class: "border-b border-slate-200"
          }, [_createElementVNode("th", {
            class: "px-4 py-3 text-left text-xs font-medium text-slate-700 uppercase tracking-wider whitespace-nowrap"
          }, "资源名称"), _createElementVNode("th", {
            class: "px-4 py-3 text-center text-xs font-medium text-slate-700 uppercase tracking-wider whitespace-nowrap"
          }, "不设置"), _createElementVNode("th", {
            class: "px-4 py-3 text-center text-xs font-medium text-slate-700 uppercase tracking-wider whitespace-nowrap"
          }, "全部数据"), _createElementVNode("th", {
            class: "px-4 py-3 text-center text-xs font-medium text-slate-700 uppercase tracking-wider whitespace-nowrap"
          }, "本部门"), _createElementVNode("th", {
            class: "px-4 py-3 text-center text-xs font-medium text-slate-700 uppercase tracking-wider whitespace-nowrap"
          }, "本部门及以下"), _createElementVNode("th", {
            class: "px-4 py-3 text-center text-xs font-medium text-slate-700 uppercase tracking-wider whitespace-nowrap"
          }, "仅本人"), _createElementVNode("th", {
            class: "px-4 py-3 text-center text-xs font-medium text-slate-700 uppercase tracking-wider whitespace-nowrap"
          }, "自定义")])], -1)), _createElementVNode("tbody", _hoisted_103, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userResourceScopes.value, (resource, index) => {
            return _openBlock(), _createElementBlock(_Fragment, {
              key: resource.resourceCode
            }, [_createElementVNode("tr", _hoisted_104, [_createElementVNode("td", _hoisted_105, [_createElementVNode("div", _hoisted_106, [_createElementVNode("span", _hoisted_107, _toDisplayString(resource.resourceName), 1), _createElementVNode("span", _hoisted_108, _toDisplayString(resource.resourceCode), 1)])]), _createElementVNode("td", _hoisted_109, [_createElementVNode("label", _hoisted_110, [_withDirectives(_createElementVNode("input", {
              type: "radio",
              name: `user-resource-${resource.resourceCode}`,
              value: 0,
              "onUpdate:modelValue": $event => resource.dataScope = $event,
              onChange: $event => onUserResourceDataScopeChange(index),
              class: "form-radio"
            }, null, 40, _hoisted_111), [[_vModelRadio, resource.dataScope, void 0, {
              number: true
            }]])])]), _createElementVNode("td", _hoisted_112, [_createElementVNode("label", _hoisted_113, [_withDirectives(_createElementVNode("input", {
              type: "radio",
              name: `user-resource-${resource.resourceCode}`,
              value: 1,
              "onUpdate:modelValue": $event => resource.dataScope = $event,
              onChange: $event => onUserResourceDataScopeChange(index),
              class: "form-radio"
            }, null, 40, _hoisted_114), [[_vModelRadio, resource.dataScope, void 0, {
              number: true
            }]])])]), _createElementVNode("td", _hoisted_115, [_createElementVNode("label", _hoisted_116, [_withDirectives(_createElementVNode("input", {
              type: "radio",
              name: `user-resource-${resource.resourceCode}`,
              value: 2,
              "onUpdate:modelValue": $event => resource.dataScope = $event,
              onChange: $event => onUserResourceDataScopeChange(index),
              class: "form-radio"
            }, null, 40, _hoisted_117), [[_vModelRadio, resource.dataScope, void 0, {
              number: true
            }]])])]), _createElementVNode("td", _hoisted_118, [_createElementVNode("label", _hoisted_119, [_withDirectives(_createElementVNode("input", {
              type: "radio",
              name: `user-resource-${resource.resourceCode}`,
              value: 3,
              "onUpdate:modelValue": $event => resource.dataScope = $event,
              onChange: $event => onUserResourceDataScopeChange(index),
              class: "form-radio"
            }, null, 40, _hoisted_120), [[_vModelRadio, resource.dataScope, void 0, {
              number: true
            }]])])]), _createElementVNode("td", _hoisted_121, [_createElementVNode("label", _hoisted_122, [_withDirectives(_createElementVNode("input", {
              type: "radio",
              name: `user-resource-${resource.resourceCode}`,
              value: 4,
              "onUpdate:modelValue": $event => resource.dataScope = $event,
              onChange: $event => onUserResourceDataScopeChange(index),
              class: "form-radio"
            }, null, 40, _hoisted_123), [[_vModelRadio, resource.dataScope, void 0, {
              number: true
            }]])])]), _createElementVNode("td", _hoisted_124, [_createElementVNode("label", _hoisted_125, [_withDirectives(_createElementVNode("input", {
              type: "radio",
              name: `user-resource-${resource.resourceCode}`,
              value: 5,
              "onUpdate:modelValue": $event => resource.dataScope = $event,
              onChange: $event => onUserResourceDataScopeChange(index),
              class: "form-radio"
            }, null, 40, _hoisted_126), [[_vModelRadio, resource.dataScope, void 0, {
              number: true
            }]])])])]), resource.dataScope === 5 ? (_openBlock(), _createElementBlock("tr", _hoisted_127, [_createElementVNode("td", _hoisted_128, [_createElementVNode("div", _hoisted_129, [_cache[79] || (_cache[79] = _createElementVNode("span", {
              class: "text-sm text-slate-600 whitespace-nowrap"
            }, "选择部门：", -1)), _createVNode(DeptSelector, {
              modelValue: resource.deptSelection,
              "onUpdate:modelValue": $event => resource.deptSelection = $event,
              multiple: "",
              placeholder: "请选择部门",
              class: "flex-1"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])])])])) : _createCommentVNode("", true)], 64);
          }), 128))])])])]))], 512), [[_vShow, permissionTab.value === 'data']])]), _createElementVNode("div", _hoisted_130, [_createElementVNode("button", {
            onClick: closeDataScopeModal,
            class: "btn-secondary"
          }, "取消"), _createElementVNode("button", {
            onClick: saveUserPermissions,
            disabled: dataScopeSaving.value,
            class: "btn-primary"
          }, _toDisplayString(dataScopeSaving.value ? '保存中...' : '确定'), 9, _hoisted_131)])]),
          _: 1
        }, 8, ["visible"]), _createVNode(AppModal, {
          visible: showBindTenantModal.value,
          size: "lg",
          scrollable: false,
          onClose: closeBindTenantModal
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_132, [_createElementVNode("div", null, [_cache[81] || (_cache[81] = _createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "分配加盟商", -1)), _createElementVNode("p", _hoisted_133, "用户：" + _toDisplayString(bindTenantUser.value?.nickname || bindTenantUser.value?.username) + "（" + _toDisplayString(bindTenantUser.value?.phone) + "）", 1)]), _createElementVNode("button", {
            onClick: closeBindTenantModal,
            class: "p-2 text-slate-400 hover:text-slate-600 rounded-lg hover:bg-slate-100 transition-colors"
          }, [...(_cache[82] || (_cache[82] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_134, [_createElementVNode("div", null, [_cache[83] || (_cache[83] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, [_createTextVNode("加盟商 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _createElementVNode("div", _hoisted_135, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => tenantSearchKeyword.value = $event),
            type: "text",
            placeholder: "搜索加盟商名称...",
            class: "form-input w-full",
            onInput: searchTenants,
            onFocus: _cache[22] || (_cache[22] = $event => showTenantDropdown.value = true)
          }, null, 544), [[_vModelText, tenantSearchKeyword.value]]), showTenantDropdown.value && filteredTenantList.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_136, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredTenantList.value, t => {
            return _openBlock(), _createElementBlock("button", {
              key: t.id,
              type: "button",
              class: _normalizeClass(["w-full text-left px-3 py-2 hover:bg-slate-50 text-sm transition-colors", bindTenantForm.tenantId === t.id ? 'bg-primary-50 text-primary-700' : 'text-slate-700']),
              onClick: $event => selectTenantOption(t)
            }, [_createElementVNode("div", _hoisted_138, _toDisplayString(t.name), 1), t.majorRegion ? (_openBlock(), _createElementBlock("div", _hoisted_139, _toDisplayString(t.majorRegion) + _toDisplayString(t.minorRegion ? ' - ' + t.minorRegion : ''), 1)) : _createCommentVNode("", true)], 10, _hoisted_137);
          }), 128))])) : _createCommentVNode("", true), showTenantDropdown.value && tenantSearchKeyword.value && filteredTenantList.value.length === 0 && !tenantListLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_140, " 无匹配的加盟商 ")) : _createCommentVNode("", true)]), bindTenantForm.tenantId ? (_openBlock(), _createElementBlock("div", _hoisted_141, [_createElementVNode("span", _hoisted_142, _toDisplayString(bindTenantForm.tenantName), 1), _createElementVNode("button", {
            type: "button",
            onClick: clearTenantSelection,
            class: "text-xs text-slate-400 hover:text-slate-600"
          }, "清除")])) : _createCommentVNode("", true)]), _createElementVNode("div", null, [_cache[84] || (_cache[84] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, [_createTextVNode("部门 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), !bindTenantForm.tenantId ? (_openBlock(), _createElementBlock("div", _hoisted_143, " 请先选择加盟商 ")) : bindTenantDeptTree.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_144, " 该加盟商下暂无部门数据 ")) : (_openBlock(), _createElementBlock("div", _hoisted_145, [_createVNode(DeptTree, {
            "tree-data": bindTenantDeptTree.value,
            "selected-dept-id": bindTenantForm.deptId,
            "expanded-ids": modalExpandedIds,
            onSelect: _cache[23] || (_cache[23] = dept => bindTenantForm.deptId = dept.id),
            onToggle: toggleModalDept
          }, null, 8, ["tree-data", "selected-dept-id", "expanded-ids"])])), bindTenantForm.deptId ? (_openBlock(), _createElementBlock("div", _hoisted_146, " 已选择：" + _toDisplayString(findDeptById(bindTenantForm.deptId)?.name || '未选择'), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", null, [_cache[85] || (_cache[85] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "昵称（可选）", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => bindTenantForm.nickname = $event),
            type: "text",
            placeholder: "在该加盟商中的昵称，不填则使用默认",
            class: "form-input w-full"
          }, null, 512), [[_vModelText, bindTenantForm.nickname]])]), _createElementVNode("div", null, [_cache[87] || (_cache[87] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "角色", -1)), _createElementVNode("div", _hoisted_147, [_createElementVNode("div", {
            onClick: _cache[25] || (_cache[25] = $event => showBindTenantRoleDropdown.value = !showBindTenantRoleDropdown.value),
            class: _normalizeClass(['form-selector-trigger w-full', {
              'is-active': showBindTenantRoleDropdown.value
            }])
          }, [bindTenantForm.roleIds.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_148, "请选择角色")) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bindTenantForm.roleIds, roleId => {
            return _openBlock(), _createElementBlock("span", {
              key: roleId,
              class: "inline-flex items-center gap-1 px-2 py-0.5 bg-primary-100 text-primary-700 rounded text-xs"
            }, [_createTextVNode(_toDisplayString(roleOptions.value.find(r => r.value === roleId)?.label || roleId) + " ", 1), _createElementVNode("button", {
              type: "button",
              onClick: _withModifiers($event => bindTenantForm.roleIds = bindTenantForm.roleIds.filter(id => id !== roleId), ["stop"]),
              class: "hover:text-primary-900"
            }, [...(_cache[86] || (_cache[86] = [_createElementVNode("svg", {
              class: "w-3.5 h-3.5",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M6 18L18 6M6 6l12 12"
            })], -1)]))], 8, _hoisted_149)]);
          }), 128))], 2), _withDirectives(_createElementVNode("div", _hoisted_150, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roleOptions.value, role => {
            return _openBlock(), _createElementBlock("label", {
              key: role.value,
              class: "flex items-center gap-2 px-3 py-2 hover:bg-slate-50 cursor-pointer"
            }, [_withDirectives(_createElementVNode("input", {
              type: "checkbox",
              value: role.value,
              "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => bindTenantForm.roleIds = $event),
              class: "form-check"
            }, null, 8, _hoisted_151), [[_vModelCheckbox, bindTenantForm.roleIds]]), _createElementVNode("span", _hoisted_152, _toDisplayString(role.label), 1)]);
          }), 128))], 512), [[_vShow, showBindTenantRoleDropdown.value]])])]), _createElementVNode("div", null, [_cache[89] || (_cache[89] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "岗位", -1)), _createElementVNode("div", _hoisted_153, [_createElementVNode("div", {
            onClick: _cache[27] || (_cache[27] = $event => showBindTenantPostDropdown.value = !showBindTenantPostDropdown.value),
            class: _normalizeClass(['form-selector-trigger w-full', {
              'is-active': showBindTenantPostDropdown.value
            }])
          }, [bindTenantForm.postIds.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_154, "请选择岗位")) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bindTenantForm.postIds, postId => {
            return _openBlock(), _createElementBlock("span", {
              key: postId,
              class: "inline-flex items-center gap-1 px-2 py-0.5 bg-green-100 text-green-700 rounded text-xs"
            }, [_createTextVNode(_toDisplayString(positionOptions.value.find(p => p.value === postId)?.label || postId) + " ", 1), _createElementVNode("button", {
              type: "button",
              onClick: _withModifiers($event => bindTenantForm.postIds = bindTenantForm.postIds.filter(id => id !== postId), ["stop"]),
              class: "hover:text-green-900"
            }, [...(_cache[88] || (_cache[88] = [_createElementVNode("svg", {
              class: "w-3.5 h-3.5",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M6 18L18 6M6 6l12 12"
            })], -1)]))], 8, _hoisted_155)]);
          }), 128))], 2), _withDirectives(_createElementVNode("div", _hoisted_156, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(positionOptions.value, pos => {
            return _openBlock(), _createElementBlock("label", {
              key: pos.value,
              class: "flex items-center gap-2 px-3 py-2 hover:bg-slate-50 cursor-pointer"
            }, [_withDirectives(_createElementVNode("input", {
              type: "checkbox",
              value: pos.value,
              "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => bindTenantForm.postIds = $event),
              class: "form-check"
            }, null, 8, _hoisted_157), [[_vModelCheckbox, bindTenantForm.postIds]]), _createElementVNode("span", _hoisted_158, _toDisplayString(pos.label), 1)]);
          }), 128))], 512), [[_vShow, showBindTenantPostDropdown.value]])])])]), _createElementVNode("div", _hoisted_159, [_createElementVNode("button", {
            onClick: closeBindTenantModal,
            class: "btn-secondary"
          }, "取消"), _createElementVNode("button", {
            onClick: confirmBindTenant,
            disabled: bindTenantLoading.value,
            class: "btn-primary"
          }, _toDisplayString(bindTenantLoading.value ? '提交中...' : '确定'), 9, _hoisted_160)])]),
          _: 1
        }, 8, ["visible"]), _createVNode(AppModal, {
          visible: showWeWorkBindModal.value,
          size: "md",
          scrollable: false,
          onClose: closeWeWorkBindModal
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_161, [_createElementVNode("div", null, [_cache[90] || (_cache[90] = _createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "绑定企业微信", -1)), _createElementVNode("p", _hoisted_162, "用户：" + _toDisplayString(weWorkBindUser.value?.nickname || weWorkBindUser.value?.username), 1)]), _createElementVNode("button", {
            onClick: closeWeWorkBindModal,
            class: "p-2 text-slate-400 hover:text-slate-600 rounded-lg hover:bg-slate-100 transition-colors"
          }, [...(_cache[91] || (_cache[91] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_163, [weWorkBindLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_164, [...(_cache[92] || (_cache[92] = [_createElementVNode("svg", {
            class: "w-5 h-5 animate-spin text-primary-600 mr-2",
            fill: "none",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("circle", {
            class: "opacity-25",
            cx: "12",
            cy: "12",
            r: "10",
            stroke: "currentColor",
            "stroke-width": "4"
          }), _createElementVNode("path", {
            class: "opacity-75",
            fill: "currentColor",
            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          })], -1), _createElementVNode("span", {
            class: "text-sm text-slate-500"
          }, "加载中...", -1)]))])) : weWorkBindInfo.value ? (_openBlock(), _createElementBlock("div", _hoisted_165, [_createElementVNode("div", _hoisted_166, [_cache[97] || (_cache[97] = _createElementVNode("div", {
            class: "flex items-center gap-2 mb-3"
          }, [_createElementVNode("span", {
            class: "w-2 h-2 rounded-full bg-green-500"
          }), _createElementVNode("span", {
            class: "text-sm font-medium text-indigo-700"
          }, "已绑定企业微信")], -1)), _createElementVNode("div", _hoisted_167, [_createElementVNode("div", _hoisted_168, [_cache[93] || (_cache[93] = _createElementVNode("span", {
            class: "text-slate-500"
          }, "企微成员ID", -1)), _createElementVNode("span", _hoisted_169, _toDisplayString(weWorkBindInfo.value.weworkUserId), 1)]), weWorkBindInfo.value.corpId ? (_openBlock(), _createElementBlock("div", _hoisted_170, [_cache[94] || (_cache[94] = _createElementVNode("span", {
            class: "text-slate-500"
          }, "企业ID", -1)), _createElementVNode("span", _hoisted_171, _toDisplayString(weWorkBindInfo.value.corpId), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_172, [_cache[95] || (_cache[95] = _createElementVNode("span", {
            class: "text-slate-500"
          }, "状态", -1)), _createElementVNode("span", {
            class: _normalizeClass(["status-badge", weWorkBindInfo.value.status === 1 ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'])
          }, _toDisplayString(weWorkBindInfo.value.status === 1 ? '启用' : '禁用'), 3)]), weWorkBindInfo.value.bindTime ? (_openBlock(), _createElementBlock("div", _hoisted_173, [_cache[96] || (_cache[96] = _createElementVNode("span", {
            class: "text-slate-500"
          }, "绑定时间", -1)), _createElementVNode("span", _hoisted_174, _toDisplayString(_ctx.$formatDateTime(weWorkBindInfo.value.bindTime)), 1)])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_175, [_createElementVNode("button", {
            onClick: handleUnbindWeWork,
            disabled: weWorkUnbindLoading.value,
            class: "btn-danger-secondary"
          }, _toDisplayString(weWorkUnbindLoading.value ? '解绑中...' : '解除绑定'), 9, _hoisted_176)])])) : (_openBlock(), _createElementBlock("div", _hoisted_177, [_cache[100] || (_cache[100] = _createElementVNode("div", {
            class: "bg-slate-50 border border-slate-200 rounded-lg p-4"
          }, [_createElementVNode("div", {
            class: "flex items-center gap-2 mb-2"
          }, [_createElementVNode("span", {
            class: "w-2 h-2 rounded-full bg-slate-400"
          }), _createElementVNode("span", {
            class: "text-sm font-medium text-slate-600"
          }, "未绑定企业微信")]), _createElementVNode("p", {
            class: "text-xs text-slate-500"
          }, "绑定后可使用企业微信相关功能")], -1)), _createElementVNode("div", null, [_cache[98] || (_cache[98] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, [_createTextVNode("企微成员UserID "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => weWorkBindForm.weworkUserId = $event),
            type: "text",
            placeholder: "请输入企业微信成员UserID",
            class: "form-input w-full"
          }, null, 512), [[_vModelText, weWorkBindForm.weworkUserId]]), _cache[99] || (_cache[99] = _createElementVNode("p", {
            class: "text-xs text-slate-400 mt-1"
          }, "可在企业微信管理后台查看成员的UserID", -1))]), _createElementVNode("div", _hoisted_178, [_createElementVNode("button", {
            onClick: closeWeWorkBindModal,
            class: "btn-secondary"
          }, "取消"), _createElementVNode("button", {
            onClick: confirmBindWeWork,
            disabled: weWorkSubmitLoading.value,
            class: "btn-primary"
          }, _toDisplayString(weWorkSubmitLoading.value ? '绑定中...' : '确认绑定'), 9, _hoisted_179)])]))])]),
          _: 1
        }, 8, ["visible"])]),
        _: 1
      });
    };
  }
};